<template>
  <keep-alive :include="['Product', 'BrandDetail']">
    <router-view :key="$route.fullPath" />
  </keep-alive>
</template>

<script>
/*
 * 네이버 공통 유입 스크립트(wcslog.js, wcs.inflow, wcs_do)는 index.html에서 처리한다.
 * 네이버페이 검수 기준상 <head>에서 스크립트를 로드하고 </body> 직전에서 wcs_do()를 호출해야 하므로,
 * Vue 컴포넌트 생명주기(SPA 라우팅마다 재실행될 수 있음)가 아닌 전역 페이지에서 한 번만 실행한다.
 */
const initIMP = () => {
  const IMP = window.IMP
  IMP.init('imp10362057')
}

export default {
  name: 'App',
  created () {
    initIMP()
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue